// extracted by mini-css-extract-plugin
module.exports = {"multiCharge":"multicharge_multiCharge__dvJM5"};